/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Activation token returned by the Kombo Connect SDK (showKomboConnect).
 * Exchanged server-side for the integration details.
 */
export interface FinalizeConnectionRequest {
  /**
     * @minLength 1
     * @maxLength 2000
     */
  activation_token: string;
}
